import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ColorSchemeToggleComponent } from '@easihub/ngx';
import { AccountWidgetComponent } from '../../account/account-widget/account.widget';

@Component({
  selector: 'header-anonymous',
  imports: [RouterModule, ColorSchemeToggleComponent, AccountWidgetComponent],
  templateUrl: './anonymous-header.component.html',
  styleUrl: './anonymous-header.component.css',
})
export class AnonymousHeaderComponent {
  protected readonly navLinks = [
    { label: 'Community', path: '/community' },
    { label: 'Tools', path: '/tools' },
    { label: 'About', path: '/about-us' }
  ] as const;
}
